import MainPageDialog from "../../../components/dialog";
import React from "react";

function DialogCover({title,children,...shareDataDetail}) {
  return (
    <div>
      <MainPageDialog
        title={title}
        footerList={[
          {
            title: "Attach",
            type: "save",
            action: () => {
              console.log(shareDataDetail,"shareDataDetail")
              shareDataDetail?.attachHandler(shareDataDetail?.selectedFiles);
            },
          },
          {
            title: "Cancel",
            type: "cancel",
            action: () => shareDataDetail?.closeDialog(),
          },
        ]}
        footer={true}
        onCancelHandler={() => {
          shareDataDetail?.closeDialog();
        }}
      >
        {children}
      </MainPageDialog>
    </div>
  );
}

export default DialogCover;
